<template>
	<div style="width: 100vw;" :style="{minHeight:'calc(100vh - ' + placeNavHeight + 'px)' }">
		<van-overlay :show="loading" style="background-color: rgb(0 0 0 / 0%);">
			<div style="display: flex;align-items: center;justify-content: center;width: 100%;height: 100%;">
				<van-loading color="#7d7d7d" type="spinner" />
			</div>
		</van-overlay>
		<div style="background-color: #fff;margin: auto;" :style="equipment == 'pc'?{
		 		// width:equipment == 'pc'?'1280px':'100%'
		 		...boxStyleOne,
				minHeight:'calc(100vh - ' + placeNavHeight + 'px)' 
		 	}:{
		 		width:'100%',
				minHeight:'calc(100vh - ' + placeNavHeight + 'px)' 
		 	}">
			<div style="height: 30px;width: 1px;"></div>
			<div v-if="data" style="">
				<div style="display: flex;justify-content: center;flex-direction: column;align-items: center;">
					<div style="display: flex;align-items: center;width: 80%;">
						<el-input v-model="searchValue" style="width: 50%;" :placeholder="$t('h.search')">
						</el-input>
						<el-select :placeholder="$t('h.selectClassfiy')" style="width: 50%;margin-left: 20px;" class="custom-select"
							@change="changePageCategories" v-model="search.category_id">
							<el-option v-for="item in list" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</div>
					<div style="height: 15px;width: 1px;"></div>
					<el-button @click="searchGoods" style="background-color: #000;color: #fff;height: 40px;width: 80%;">
						<span>
							{{$t('h.search')}}
						</span>
					</el-button>
					<div style="height: 10px;width: 1px;"></div>
				</div>
				
				<div style="display: flex;justify-content: center;width: 100%;"
					v-if="data.products.data.length == 0">
					<el-empty style="margin: auto;margin-top: 40px;" :description="$t('h.noData')"></el-empty>
				</div>

				<div :style="getColumns()"
					style="max-width: 100%;display: grid;margin-top: 10px;justify-content: space-around;">
					<single-goods style="max-width: 100%;" v-for="(item,index) in data.products.data" :key="index"
						:goodsData="{
							...item,
							image_format:item.images[0]
						}" :equipment="equipment" :selectdItem="selectdItem" type="build"></single-goods>
				</div>

				<!-- <div :style="getLayStyle()" style="display: flex;flex-wrap: wrap;">
					<div v-if="data.products.data.length > 0" @click="navTo(item)" :style="{
						boxShadow:selectItem &&  selectItem.id == item.id?' 0 0 10px 1px #999 ':'none',
						width: equipment == 'pc'?'300px':'46%',height: equipment == 'pc'?'auto':'auto',
						marginLeft: equipment == 'pc'?'30px':'4px'
					}" @mouseleave.stop.prevent="leaveGoods" @mouseenter.stop.prevent="entGood(item)"
						style="margin-top: 20px;cursor: pointer;" v-for="(item,index) in  data.products.data"
						:key="index">
						<div style="position: relative;width: 100%;">
							<img v-lazy="item.images && item.images.length > 0?item.images[0]:''"
								style="width: 100%;aspect-ratio: 1/1;"
								:src="item.images && item.images.length > 0?item.images[0]:''" />
							<div v-if="selectItem &&  selectItem.id == item.id"
								style="height: 40px;background-color: #000;width: 100%;display: flex;color: #fff;position: absolute;bottom: 0px;align-items: center;justify-content: space-between;">
								<div @click.stop.prevent="addCart(item)"
									style="width: 80%;border-right: solid 1px #aaaaaa;height: 100%;display: flex;justify-content: center;align-items: center;">
									{{$t('h.addCart')}}
								</div>
								<div @click.stop.prevent="collect(item)"
									style="width: 20%;text-align: center;font-size: 18px;" v-if="item.in_wishlist == 0">
									<i style="color: #fff;" class="el-icon-star-off"></i>
								</div>
								<div @click.stop.prevent="collect(item)"
									style="width: 20%;text-align: center;font-size: 18px;" v-if="item.in_wishlist != 0">
									<i style="color: #fff;" class="el-icon-star-on"></i>
								</div>
							</div>
						</div>
						<div :style="{
						 	width:equipment == 'pc'?'300px':'100%'
						 }" style="text-align: center;margin-top: 10px;" class="tit">
							{{item.name_format}}
						</div>
						<div :style="{
							width:equipment == 'pc'?'300px':'100%',
							marginLeft: equipment == 'pc'?'0px':'0px'
						}" style="display: flex;justify-content: center;margin-top: 10px;">
							<div style="color: #635bff;">
								{{item.price_format}}
							</div>
							<div class="original-price" style="margin-bottom: 10px;margin-left: 10px;">
								{{item.origin_price_format}}
							</div>
						</div>
					</div>

				</div> -->
			</div>
			<div style="height: 40px;width:  1px;"></div>
			<!-- <div v-if="data && data.products.data.length > 0" class="block"
				style="width: 100%;display: flex;justify-content: center;">
				<el-pagination @current-change="currentChange" :page-size="20" layout="prev, pager, next"
					:total="data.products.total">
				</el-pagination>
			</div> -->
			
			
			<div style="margin-top: 20px;width: 100%;display: flex;justify-content: center;" v-if="data && data.products.data.length > 0">
				<div style="display: flex;align-items: center;">
					<el-pagination @current-change="currentChange" :page-size="20" layout="prev, pager, next"
						:total="data.products.total" :style="{
						'--hoverColor':selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationHoverColor,
						'--selectColor':selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationSelectColor
					}">
					</el-pagination>
					<div :style="{
						color:selectdItem.compontChildren[0].layoutConfig.classFiyConfig.paginationSelectColor
					}" style="font-size: 13px;">{{$t('h.allNum')}} {{data.products.total}} </div>
				</div>
			</div>
			
			<div style="height: 30px;width:  1px;"></div>
		</div>
		<!-- <div v-if="data && data.products_format.length == 0" style="display: flex;justify-content: center;width: 100%;">
			<el-empty style="margin: auto;margin-top: 40px;" description="empty"></el-empty>
		</div> -->
		<el-dialog title="" :visible.sync="dialogVisible" :width="equipment == 'phone'?'90%':'60%'"
			:before-close="()=>{dialogVisible = false}">
			<div v-loading="iframeLogin">
				<iframe v-if="dialogVisible" id="iframe" style="width: 100%;min-height: 650px;" ref="iframe"
					src="/login?iframe=true" frameborder="0" scrolling="auto" @load="iframeLogin = false"></iframe>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getSearchCategory,
		getAccountCollect,
		getProductsSearchData
	} from '../../../api/all.js'
	import singleGoods from '../../components/singleGoods.vue'

	import {
		mapState,
		mapGetters,
		mapActions,
		mapMutations
	} from 'vuex';
	import lodash from 'lodash';
	export default {
		components: {
			singleGoods
		},
		props: {
			boxStyleTwo: {
				type: Object,
				default: () => {
					return {}
				}
			},
			boxStyleOne: {
				type: Object,
				default: () => {
					return {}
				}
			},
			equipment: {
				type: String,
				default: "pc"
			},
			localPageData: {
				type: Object,
				default: () => {
					return {}
				}
			},
			placeNavHeight: {
				type: Number,
				default: 0
			},

		},
		computed: {
			...mapState("lowCodeStore", ['goodsConfig','classifyListPreview']),
		},
		data() {
			return {
				selectdItem:{
					compontChildren:[{
						layoutConfig:{
							classFiyConfig:{
								paginationHoverColor:"#55aaff",
								paginationSelectColor:"#55aaff"
							},
							goodsConfig:{}
						}
					}]
				},
				value: "",
				list: [],
				searchValue: "",
				iframeLogin: false,
				dialogVisible: false,
				selectItem: null,
				search: {
					page: 1,
					keyword: "",
					category_id: ""
				},
				loading: false,
				data: null
			}
		},
		mounted() {
			
			if (this.goodsConfig.length > 0) {
				console.log('classifyListPreview',this.classifyListPreview)
				if(this.classifyListPreview.length > 0){
					
					this.classifyListPreview.forEach(item=>{
						if(item.name == '商品分类'){
							 this.selectdItem.compontChildren[0].layoutConfig.classFiyConfig = lodash.cloneDeep(item.children[0].children[0].compontChildren[0].layoutConfig.classFiyConfig)
						}
					})
					
					// this.selectdItem.compontChildren[0].layoutConfig.classFiyConfig = this.classifyListPreview[0].compontChildren[0].layoutConfig.classFiyConfig
				}
				this.selectdItem.compontChildren[0].layoutConfig.goodsConfig = lodash.cloneDeep(this.goodsConfig[0])
				this.$forceUpdate()
			}
			
			
			console.log('$route', this.$route)
			if (this.$route.query.keyword) {
				this.search.keyword = this.$route.query.keyword
				this.searchValue = this.$route.query.keyword
			}

			if (this.$route.query.category_id) {
				this.search.category_id = parseInt(this.$route.query.category_id)
			}

			let that = this
			window.addEventListener('message', function(event) {
				console.log('eventeventevent', event)
				if (event && event.data.data.status == "success") {
					that.dialogVisible = false
					localStorage.setItem('address', JSON.stringify(event.data.data.data))
					// that.$message.success(event.data.data.message)
				}
			});
			this.getCategory()
			this.getData()

		},
		methods: {
			
			
			getColumns() {
				let goodsConfig = lodash.cloneDeep(this.goodsConfig[0])
				let num = 1
				if (this.equipment == 'pc') {
					num = goodsConfig.pcNum
				} else {
					num = goodsConfig.phoneNum
				}
				
				let gridRowGap;
				let gridColumnGap;
				if(this.equipment == 'pc'){
					gridRowGap = goodsConfig.rowGap + 'px'
					gridColumnGap = goodsConfig.columnGap + 'px'
				}else{
					gridRowGap = goodsConfig.phoneRowGap + 'px'
					gridColumnGap = goodsConfig.phoneColumnGap + 'px'
				}
				
				console.log('getColumnsgridRowGap',gridRowGap)
				console.log('gridColumnGap',gridColumnGap)
				return {
					gridRowGap: gridRowGap,
					gridColumnGap: gridColumnGap,
					gridTemplateColumns: `repeat(auto-fill, calc(${parseInt(100 / num)}% - ${this.equipment == 'pc'?goodsConfig.columnGap: goodsConfig.phoneColumnGap}px))`
				}
			},
			
			
			// getColumns() {
			// 	letgoodsConfig = lodash.cloneDeep(this.goodsConfig[0])
				
				
			// 	let num = 1
			// 	if (this.equipment == 'pc') {
			// 		num = goodsConfig.pcNum
			// 	} else {
			// 		num = goodsConfig.phoneNum
			// 	}
				
			// 	console.log('this.selectdItem.compontChildren[0].layoutConfig',this.selectdItem.compontChildren[0].layoutConfig)
				
			// 	return {
			// 		gridRowGap: this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.rowGap + 'px',
			// 		gridColumnGap: this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.columnGap + 'px',
			// 		gridTemplateColumns: `repeat(auto-fill, calc(${parseInt(100 / num)}% - ${this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.columnGap}px))`
			// 	}
			// },
			changePageCategories() {

			},
			async getCategory() {
				const data = await getSearchCategory()
				console.log('getDatadata', data)
				this.list = data.data.data
				this.$forceUpdate()

			},
			searchGoods() {
				this.search.keyword = this.searchValue
				this.getData()
			},
			async collect(item) {
				console.log('item', item)
				try {
					console.log(this.sku)
					this.loading = true
					let wsid = this.$cookies.get("wsid")
					let data = await getAccountCollect({
						wsid,
						product_id: item.id
					})
					console.log(data)
					this.$message.success(data.data.message)
					this.loading = false
					if (item.in_wishlist == 0) {
						item.in_wishlist = 1
					} else {
						item.in_wishlist = 0
					}
					// this.isCollct = !this.isCollct
				} catch (e) {
					if (e.status == 401) {
						this.dialogVisible = true
						this.iframeLogin = true
					}
					this.loading = false
					console.log('e', e)
				}
			},
			navTo(item) {
				this.$router.push({
					path: '/products/' + item.url_name,

				})
			},
			getLayStyle() {
				if (this.equipment == 'pc') {
					return 'display: grid;cursor: pointer;grid-template-columns: repeat(auto-fill, 300px); grid-gap: 40px 40px;justify-content: center;'
				} else {
					return {
						display: 'flex',
						flexWrap: 'wrap'
					}
				}
			},
			currentChange(e) {
				this.search.page = e
				this.getData()
			},
			leaveGoods() {
				this.selectItem = null
			},
			entGood(item) {
				this.selectItem = item
			},
			async getData() {
				try {
					this.loading = true
					const data = await getProductsSearchData({
						...this.search
					})
					console.log('data', data)
					this.data = data.data.data
					this.loading = false
				} catch (e) {
					this.loading = false
				}
				// await
			}
		}
	}
</script>

<style scoped lang="scss">
	.tit {
		display: -webkit-box;
		/* 设置为WebKit内核的弹性盒子模型 */
		-webkit-box-orient: vertical;
		/* 垂直排列 */
		-webkit-line-clamp: 1;
		/* 限制显示两行 */
		overflow: hidden;
		/* 隐藏超出范围的内容 */
		text-overflow: ellipsis;
	}

	::v-deep .el-input__inner:focus {
		border: solid 1px #000000;
	}

	::v-deep .el-select .el-input.is-focus .el-input__inner {
		border: 1px solid #000000;
	}

	::v-deep .el-select .el-input__inner:focus {
		border: 1px solid #000000;
	}
	
	::v-deep .el-pager {
	
		.active {
			color: var(--selectColor);
		}
	
		li:hover {
			color: var(--hoverColor);
		}
	
		li {
			background-color: rgb(0 0 0 / 0%);
		}
	}
	
	::v-deep .el-pagination {
		.btn-prev {
			background-color: rgb(0 0 0 / 0%);
		}
	
		.btn-next {
			background-color: rgb(0 0 0 / 0%);
		}
	
		button:hover {
			color: var(--hoverColor);
		}
	}
	
</style>